import {Dialog} from '@headlessui/react';

interface ModalProps {
  children: React.ReactNode;
  closeMaskOnClick?: boolean;
  handleModalClose?: () => void;
  showCloseButton?: boolean;
  visible?: boolean;
}

function Modal({
  children,
  closeMaskOnClick = true,
  handleModalClose = () => {},
  showCloseButton = true,
  visible = false,
}: ModalProps) {
  return (
    <Dialog open={visible} onClose={closeMaskOnClick ? handleModalClose : () => {}} data-testid="modal-dialog">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto max-w-fit max-h-[90vh] rounded bg-white relative flex flex-col">
          {showCloseButton && (
            <button onClick={handleModalClose} className="absolute top-2 right-2 text-xl hover:text-gray-500 z-10">
              ×
            </button>
          )}
          <div className="overflow-y-auto p-4">{children}</div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}

export default Modal;
